export default __webpack_public_path__ + "static/media/car_act.1757962a.svg";